import { useMutation } from 'react-query'
import { axiosInstance } from '../api/http'

export const useUpload = () => {
  return useMutation((formData: FormData) => {
    // Bypass the generated API client so Axios can automatically set the
    // correct multipart/form-data Content-Type boundary for FormData uploads.
    return axiosInstance.instance.post('/files', formData)
  })
}
